import english from './english';

const translations = {
  english,
};

export default translations;
